import React, { useState } from "react";
import { Link } from "react-router-dom";
import Slider from "react-slick";
import { FaArrowLeft, FaArrowRight } from "react-icons/fa";
import projectList from "../assets/projectList";


// Custom Arrows
const NextArrow = ({ onClick }) => (
  <button
    onClick={onClick}
    className="absolute right-0 top-1/2 -translate-y-1/2 bg-black/50 text-white p-2 rounded-full z-10"
  >
    <FaArrowRight className="h-6 w-6" />
  </button>
);

const PrevArrow = ({ onClick }) => (
  <button
    onClick={onClick}
    className="absolute left-0 top-1/2 -translate-y-1/2 bg-black/50 text-white p-2 rounded-full z-10"
  >
    <FaArrowLeft className="h-6 w-6" />
  </button>
);

const RelatedProjects = () => {
  const [hoveredCard, setHoveredCard] = useState(null);
  const settings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 2000,
    nextArrow: <NextArrow />,
    prevArrow: <PrevArrow />,
    responsive: [
      { breakpoint: 1024, settings: { slidesToShow: 2 } },
      { breakpoint: 768, settings: { slidesToShow: 1 } },
    ],
  };

  return (
    <div className="mx-auto px-4 py-16 md:px-6 lg:px-8 font-manrope bg-[#f7f8fd]">
      <div className="mb-12" data-aos="fade-up">
        <h1 className="text-5xl font-bold leading-tight md:text-4xl lg:text-6xl mb-4 md:mb-0">
          Related Projects
        </h1>
      </div>
      <Slider {...settings}>
        {projectList.map((portfolio) => (
            <div
            key={portfolio.id}
            className="px-3"
            onMouseEnter={() => setHoveredCard(portfolio.id)}
            onMouseLeave={() => setHoveredCard(null)}
          >
            <Link to={`/portfolio-grid/${portfolio.id}`} className="block">
            <div className="flex flex-col gap-2 shadow-lg mx-6 rounded-3xl relative bg-[#f7f8fd] overflow-hidden">
              <img
                src={portfolio.image}
                alt={portfolio.title}
                loading="lazy"
                className="w-full object-cover rounded-t-3xl"
              />
              <div className="absolute bottom-0 left-0 right-0 p-6">
                <div className="bg-white rounded-md shadow-md relative overflow-hidden">
                  <div
                    className="w-1 bg-blue-800 absolute left-0 transition-all duration-300"
                    style={{
                      height: hoveredCard === portfolio.id ? "100%" : "24px",
                      top: hoveredCard === portfolio.id ? "0" : "calc(50% - 12px)",
                    }}
                  />
                  <div className="p-6 pl-8">
                    <p className="text-[#504e9a] font-semibold mb-1">{portfolio.category}</p>
                    <h3 className="text-2xl font-bold text-gray-900">{portfolio.title}</h3>
                  </div>
                </div>
              </div>
            </div>
            </Link>
          </div>
        ))}
      </Slider>
    </div>
  );
};

export default RelatedProjects;
